import React, { useState } from "react";
import { apiUrl } from "../config/config";

const OrderModal = ({ order, onClose }) => {
  const [activeTab, setActiveTab] = useState("info");

  if (!order) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4">
      <div className="bg-white w-full max-w-5xl rounded-xl shadow-2xl overflow-hidden flex flex-col max-h-[90vh]">
        {/* Header */}
        <div className="flex justify-between items-center px-6 py-4 border-b">
          <h2 className="text-2xl font-bold">Order #{order.id} Details</h2>
          <button
            onClick={onClose}
            className="text-white bg-red-600 px-4 py-2 rounded-lg hover:bg-red-700 transition"
          >
            Close
          </button>
        </div>
        {/* Tabs */}
        <div className="flex border-b">
          <button
            onClick={() => setActiveTab("info")}
            className={`flex-1 text-center py-2 font-semibold ${
              activeTab === "info"
                ? "border-b-4 border-blue-600 text-blue-600"
                : "text-gray-600 hover:text-blue-600"
            } transition`}
          >
            Order Info
          </button>
          <button
            onClick={() => setActiveTab("items")}
            className={`flex-1 text-center py-2 font-semibold ${
              activeTab === "items"
                ? "border-b-4 border-blue-600 text-blue-600"
                : "text-gray-600 hover:text-blue-600"
            } transition`}
          >
            Items
          </button>
        </div>

        {/* Content */}
        <div className="p-6 overflow-y-auto flex-1">
          {activeTab === "info" && (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="bg-gray-50 p-4 rounded-lg shadow-sm space-y-2">
                <h3 className="text-lg font-semibold mb-2">Billing & Shipping</h3>
                <p><strong>Name:</strong> {order.first_name} {order.last_name}</p>
                <p><strong>Address:</strong> {order.address}, {order.city}, {order.country} - {order.zip}</p>
                <p><strong>Mobile:</strong> {order.mobile}</p>
                <p><strong>Email:</strong> {order.email}</p>
                <p><strong>Notes:</strong> {order.notes || "None"}</p>
              </div>
              <div className="bg-gray-50 p-4 rounded-lg shadow-sm space-y-2">
                <h3 className="text-lg font-semibold mb-2">Payment & Summary</h3>
                <p><strong>Payment Method:</strong> {order.payment_method}</p>
                <p><strong>Payment Status:</strong> {order.payment_status}</p>
                <p><strong>Subtotal:</strong> ${order.subtotal}</p>
                <p><strong>Shipping:</strong> ${order.shipping}</p>
                <p><strong>Total:</strong> ${order.total}</p>
                <p><strong>Order Date:</strong> {new Date(order.created_at).toLocaleString()}</p>
              </div>
            </div>
          )}

          {activeTab === "items" && (
            <div className="overflow-x-auto">
              <table className="w-full border text-left text-gray-700 min-w-[800px]">
                <thead className="bg-gray-100 font-semibold sticky top-0 z-10">
                  <tr>
                    <th className="px-4 py-2">Product</th>
                    <th className="px-4 py-2">Name</th>
                    <th className="px-4 py-2">Qty</th>
                    <th className="px-4 py-2">Price</th>
                    <th className="px-4 py-2">Total</th>
                    <th className="px-4 py-2">Filters</th>
                    <th className="px-4 py-2">Inputs</th>
                    <th className="px-4 py-2">Dimensions</th>
                  </tr>
                </thead>
                <tbody>
                  {order.items.map((item, idx) => (
                    <tr key={item.id} className={`${idx % 2 === 0 ? "bg-white" : "bg-gray-50"} hover:bg-blue-50 transition`}>
                      <td className="px-4 py-2">
                        {item.upload_image && (
                          <img
                            src={`${apiUrl}/storage/${item.upload_image}`}
                            alt={item.product_name}
                            className="w-16 h-16 object-cover rounded shadow-sm"
                          />
                        )}
                      </td>
                      <td className="px-4 py-2 font-medium">{item.product_name}</td>
                      <td className="px-4 py-2">{item.qty}</td>
                      <td className="px-4 py-2">${item.price}</td>
                      <td className="px-4 py-2">${item.total}</td>
             <td className="px-4 py-2 text-sm">
  {item.selected_filters
    ? Object.entries(item.selected_filters).map(([key, value]) => (
        <div key={key}>
          <strong>{key}:</strong> {value}
        </div>
      ))
    : "-"}
</td>

<td className="px-4 py-2 text-sm">
  {item.inputs
    ? Object.entries(item.inputs).map(([key, value]) => (
        <div key={key}>
          <strong>{key}:</strong> {value}
        </div>
      ))
    : "-"}
</td>
                      <td className="px-4 py-2">{item.width} x {item.height}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default OrderModal;
